export default __webpack_public_path__ + "static/media/Empresa3.32669e30.png";